import { detectEnv } from "../../Components/Common/utils/detectEnv";

export async function getHeaderContent() {
    const quotationCode = JSON.parse(localStorage.getItem('config') ?? '{}').quotation_code;

    let data = null;
    let is_bonogo = detectEnv().mirror === 'bonogo';
    if (is_bonogo) {
        try {
            data = (await import(`../hardCodedHeader/bonogo`)).default;
        } catch (error) {
            console.error(error);
        }
    } else if (quotationCode) {
        try {
            data = (await import(`../hardCodedHeader/${quotationCode}.ts`)).default;
        } catch (error) {
            console.error(error);
        }
    }

    const defaultHeader = (await import(`../hardCodedHeader/beachcomber`)).default;

    return data ?? {
        ...defaultHeader,
        logo: undefined,
        transparentLogo: undefined
    };
}